import { formaterPoints, formaterPourcentage } from '@gsm/partage';

export interface LigneReglette {
  cle: string;
  libelle: string;
  precision?: string;
  reelPct: string | null;
  ciblePct: string;
  tolerancePts?: number;
}

/**
 * Réglette d'allocation (charte, doc 06, § 6.4) — composant emblématique.
 *
 * L'échelle est COMMUNE à toutes les lignes affichées et calée sur la plus
 * forte cible : une échelle par ligne rendrait les barres incomparables, et
 * une échelle 0–100 % tasserait tout à gauche puisqu'une ligne dépasse
 * rarement 15 %.
 */
export function RegleAllocation({
  lignes,
  echelleMax,
}: {
  lignes: LigneReglette[];
  echelleMax?: number;
}) {
  const maxCible = Math.max(...lignes.map((l) => Number(l.ciblePct)), 0);
  const maxReel = Math.max(...lignes.map((l) => Number(l.reelPct ?? 0)), 0);
  // Arrondi au palier de 5 points supérieur, minimum 10.
  const echelle = echelleMax ?? Math.max(10, Math.ceil(Math.max(maxCible, maxReel) / 5) * 5);
  const pos = (valeur: number) => Math.min(100, (valeur / echelle) * 100);

  return (
    <div className="reglette">
      <div className="reglette__echelle surtitre">échelle 0 – {echelle} %</div>
      {lignes.map((l) => {
        const cible = Number(l.ciblePct);
        const reel = l.reelPct === null ? null : Number(l.reelPct);
        const ecart = reel === null ? null : reel - cible;
        const tolerance = l.tolerancePts ?? 0.5;

        return (
          <div className="regle" key={l.cle}>
            <div className="regle__nom">
              {l.libelle}
              {l.precision && <em>{l.precision}</em>}
            </div>

            <div className="piste">
              <span
                className="piste__tolerance"
                style={{
                  left: `${pos(Math.max(0, cible - tolerance))}%`,
                  width: `${pos(2 * tolerance)}%`,
                }}
              />
              {reel !== null && <span className="piste__reel" style={{ width: `${pos(reel)}%` }} />}
              <span className="piste__cible" style={{ left: `${pos(cible)}%` }} />
            </div>

            <div className="regle__chiffres">
              <span>{reel === null ? '—' : formaterPourcentage(String(reel))}</span>
              <span className="regle__cible">{formaterPourcentage(l.ciblePct)}</span>
              <span
                className={
                  ecart === null || Math.abs(ecart) < 0.005
                    ? 'nul'
                    : ecart > 0
                      ? 'hausse'
                      : 'baisse'
                }
              >
                {ecart === null ? '—' : formaterPoints(String(ecart))}
              </span>
            </div>
          </div>
        );
      })}
    </div>
  );
}
